module.exports = __webpack_public_path__ + "static/media/windturbine_alone.bd4d670a.jpg";